import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getTeacherAccessPermissionsDataType} from "./__graphql-types__/index.ts";

export const TEACHER_ACCESS_PERMISSIONS_DATA: GqlOperation<
    getTeacherAccessPermissionsDataType["response"],
    getTeacherAccessPermissionsDataType["variables"]
> = gqlOp(gql`
    query getTeacherAccessPermissionsData {
        user {
            id
            age
            joined
            isTeacher
            isFormalTeacher
            isK4dTeacher
            hasAccessToAIGuideTeacher
            isAIGuideEnabled
            hasChildren
            hasClasses
            isKmapStudent
            isK4dStudent
            hasAccessToAIGuideDistrictClassroomTeacher
            classrooms {
                id
                cacheId
                isK4dClassroom
            }
            coachedChildAssignmentsClassrooms {
                id
                cacheId
                students {
                    id
                    includesDistrictOwnedData
                }
            }
            userDistrictInfos {
                id
                district {
                    id
                    hasAssessments
                    hasAssessmentsPilots
                }
            }
        }
    }
`);
